import styled from 'styled-components';

export const SearchContainer = styled.div`
  position: relative;
  width: ${props => props.$width || '100%'};
  display: flex;
  align-items: center;
  z-index: 999999;
`;

// All other styles removed as they're no longer needed with MUI components
